var React = require('react');

function PivotalP (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.2865,4l-10.96091.00231V44h6.80363V10.03923H20.531c.79551.00679,1.538.033,2.2094.04729,5.564.10808,8.33445,1.80535,8.33445,6.12006,0,.1743.01.28654.01.46747,0,3.98945-2.19706,6.63694-8.25111,6.63694a12.96267,12.96267,0,0,1-1.45232-.12557v5.53228s.865-.00722,1.45742-.00722c8.69419,0,14.83549-3.41059,14.83549-11.9753,0-.17184-.01182-.34759-.01182-.517C37.66259,7.34105,30.98091,4,21.2865,4Z"}));
}

PivotalP.displayName = "PivotalP";

PivotalP.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PivotalP;

PivotalP.default = PivotalP;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/pivotal_p.svg